import cloudflareAssets from "@/assets/cloudflareAssets";
import type { IAccount } from "@/modules/account/common/types";
import { MoreIcon } from "@/shared/components/SvgIcons";
import { Divider } from "@ab.uitools/ui-library/components/Divider";
import { Image } from "@ab.uitools/ui-library/components/Image";
import { Text } from "@ab.uitools/ui-library/components/Text";

interface Props extends IAccount {
  index: number;
  hasBalanceVisibility?: boolean;
  hasMoreAction?: boolean,
  rounded?: boolean
}

export const ClosedAccountItem = (
  {
    description,
    number,
    index,
    closingDate,
    hasMoreAction,
    rounded = false,
  }: Props) => {

  return (
    <div className="flexbox align-items--center pl-32 pr-32 close-account-widget-content-item">
      <div className={`card-account-image flexbox ${rounded ? "rounded" : ""}`}>
        <Image imagePath={cloudflareAssets.Account}/>
      </div>
      <div className="full-width flexbox flex-direction--column pl-16 card-account-content-wrapper">
        {!!index && (
          <Divider
            color="light"
            type="primary"
            isHorizontal
          />
        )}
        <div className="flexbox full-width pt-20 pb-20 card-account-body-wrapper">
          <div className="flexbox flex-direction--column card-account-body">
            <div className="full-width flexbox justify-content--between">
              <Text
                size="medium"
                weight="semibold"
                className="pr-16 truncate card-account-name"
              >
                {description}
              </Text>
              <div
                className="flexbox justify-content--center align-items--end flex-direction--column pr-6">
                <Text className="pl-8 text-nowrap">{closingDate}</Text>
              </div>
            </div>
            <div className="flexbox align-items--center">
              <Text className="card-account-number">
                {number}
              </Text>
            </div>
          </div>
          {hasMoreAction && (
            <div className="cursor-pointer flexbox align-items--center">
              <MoreIcon type="secondary"/>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
